import type { ItineraryCanvasserRowDto } from '../../../types/campaign'

/** Heads-up copy when a canvasser already has turf(s) on `dateStr`; null when the day is clear. */
export function sameDayHeadsUp(
  canvassers: ItineraryCanvasserRowDto[],
  grantId: string,
  dateStr: string,
  excludeAssignmentId?: string,
): string | null {
  const row = canvassers.find(c => c.grantId === grantId)
  const existing = (row?.dayAssignments[dateStr] ?? []).filter(a => a.id !== excludeAssignmentId)
  if (!row || existing.length === 0) return null
  const weekday = new Date(dateStr + 'T00:00:00').toLocaleDateString(undefined, { weekday: 'long' })
  const extras = existing.length - 1
  const what = extras > 0 ? `${existing[0].turfLabel} and ${extras} more` : existing[0].turfLabel
  return `${row.fullName} already has ${what} on ${weekday}.`
}
